export default __webpack_public_path__ + "static/media/harvey-logo.a76c6382.png";